{
  "common": {
    "editProfile": "Edit Profile",
    "settings": "Settings",
    "dashboard": "Dashboard",
    "logout": "Logout",
    "save": "Save",
    "cancel": "Cancel",
    "submit": "Submit",
    "sort": "Sort",
    "back": "back to overview",
    "exportImport": "Export/Import",
    "export": "Export products",
    "download": "Download",
    "copyService": "Copy Service",
    "copyWebsite": "Copy Website",
    "copySettings": "Copy Settings",
    "info": "More information"
  },
  "settings": {
    "deleteSecret": "Delete Secret",
    "deleteSecretHint": "Are you sure you want to delete the user's secret? This action cannot be undone!",
    "username": "Username",
    "email": "Email Address",
    "name": "Display Name",
    "role": "Role",
    "phone": "Phone",
    "customer": "Customer",
    "changePassword": "Change Password",
    "oldPassword": "Old Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm New Password",
    "passwordError": "An error occurred! Please check your input!",
    "passwordChangeSuccess": "Password successfully changed",
    "adminChangePassword": "Change Password (Admin)",
    "adminPasswordChangeInfo": "You are changing the password for user",
    "userWillBeNotified": "The user will be notified by email.",
    "reasonForChange": "Reason for change",
    "reasonHelperText": "This information will be stored in the audit log",
    "passwordRequirements": "Password Requirements:",
    "minLength": "At least 8 characters",
    "uppercase": "At least one uppercase letter",
    "lowercase": "At least one lowercase letter",
    "digit": "At least one digit",
    "specialChar": "At least one special character",
    "passwordsDoNotMatch": "Passwords do not match",
    "reasonRequired": "Please provide a reason"
  },
  "messages": {
    "copyServiceError": "The service could not be copied.",
    "copyWebsiteError": "The website could not be copied.",
    "copySettingsError": "The settings could not be copied.",
    "passwordChangeError": "Error changing password"
  }
}
